import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import * as m from "@paraglide/messages"
import { imageRenderProps } from "@shared/lib/componentUtils"
import OptimizedImage from "@shared/ui/OptimizedImage"
import { useRouteShellContext } from "@shared/ui/routeShellContext"
import type { AgencyProps } from "@site-types/components/agency"
import ScrollArrow from "../ScrollArrow"
export function Agency({ gamersImage }: AgencyProps) {
  const { locale } = useRouteShellContext()
  return (
    <section
      className="relative min-h-[unset] w-full overflow-x-hidden bg-[linear-gradient(to_bottom,transparent_0%,var(--deep-purple)_80%)] p-[2rem] [scroll-snap-align:start] lg:flex lg:items-center"
      id="agency"
      data-testid="home-agency"
    >
      {gamersImage ? (
        <OptimizedImage
          className="m-auto flex h-auto w-4/5 object-contain lg:max-h-[65%] lg:max-w-[50%] xl:m-0 xl:max-h-full xl:w-1/2"
          alt="company culture"
          {...imageRenderProps(gamersImage, "workModal")}
        />
      ) : null}
      <div className="mb-[100px] w-full lg:pr-[10lvw]">
        <h2 className="text-[2.5rem] lg:text-[4rem]">{m.home_agency_title({}, { locale: locale })}</h2>
        <p className="my-[2.5rem] text-[2rem] lg:text-[2.5rem]">
          <strong
            dangerouslySetInnerHTML={{
              __html: sanitizeRichHtml(m.home_agency_pointOneBold({}, { locale: locale })),
            }}
          />
          <br />
          {m.home_agency_pointOne({}, { locale: locale })}
        </p>
        <p className="my-[2.5rem] text-[2rem] lg:text-[2.5rem]">
          <strong>{m.home_agency_pointTwoBold({}, { locale: locale })}</strong>
          <br />
          {m.home_agency_pointTwo({}, { locale: locale })}
        </p>
        <p className="my-[2.5rem] text-[2rem] lg:text-[2.5rem]">
          <strong>{m.home_agency_pointThreeBold({}, { locale: locale })}</strong>
          <br />
          {m.home_agency_pointThree({}, { locale: locale })}
        </p>
        <a
          className="my-[2.5rem] hidden text-[2rem] md:block lg:text-[2.5rem]"
          href={`/${locale}/work`}
          dangerouslySetInnerHTML={{
            __html: sanitizeRichHtml(m.home_agency_pointFour({}, { locale: locale })),
          }}
        />
      </div>
      <ScrollArrow
        href="#brands"
        label="Scroll to brands"
      />
    </section>
  )
}

export default Agency
